import { useEffect, useState, useRef } from 'react';
import { Button } from 'react-bootstrap';
import { useStore } from 'store';
import { fetchReviews, setReviewsParams } from 'store/actions/reviews';
import './style.scss';
import { ReviewsCardsv2 } from '../ReviewsCards2';
import {useWindowSize} from 'hooks'

export const ReviewListv2 = () => {
  const [listOfReviews, dispatch] = useStore(
    ({ reviews }) => reviews.listOfReviews
  );
  const { isMobile } = useWindowSize({ largeMobile: true })[1];
  const [hiddenButton, setHiddenButton] = useState(false);
  const [getOrderBy, setOrderBy] = useState();
  const isMountedRef = useRef(false);
  const { params = {} } = listOfReviews;
  const { totalPages } = listOfReviews;

  const handleClick = () => {
    if (totalPages >= params.page) {
      dispatch(setReviewsParams({ page: params.page + 1 }));
    }

    setHiddenButton(true);
  };

  useEffect(() => {
    if (totalPages >= params.page) {
      dispatch(fetchReviews({ incrementalList: true }));
    }
  }, [params.page]);

  useEffect(() => {
    if (isMountedRef.current) {
      dispatch(fetchReviews({ withLoader: true }));
    } else {
      isMountedRef.current = true;
    }
  },[getOrderBy])
  

  const getReviewsOrder = (event) => {
    event.preventDefault();
    dispatch(setReviewsParams({page: 1, size: 10, orderBy: 'DESC' , order_field:'createdAt'}));
    setOrderBy('DESC') 
  }

  return (
    <div>
      <div className="ContainerReviews pb-4">
        <div className=" ContainerCards__scrollContainer">
          <div className="ContainerCards__scrollContainerScroll ">

            {!isMobile && (<h5>Ordenar por: <a href="#" onClick={getReviewsOrder}>Más recientes</a> </h5>)}
            <br></br>
            <ReviewsCardsv2 showAddReview />
          </div>
        </div>
        {totalPages !== params.page && (
          <div className="container text-center Review py-0">
            <Button
              hidden={hiddenButton}
              onClick={handleClick}
              className="px-5 button-more-reviews"
              variant="primary"
              type="button"
            >
              Ver más reseñas
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};
